import { SPORTS, type Sport, type ThresholdKind, type ThresholdSport } from './vocab';

// Max HR is one person-wide history, stored under ride.
export const SPORT_KINDS: Record<ThresholdSport, readonly ThresholdKind[]> = {
  ride: ['ftp', 'lthr', 'max_hr'],
  run: ['threshold_pace', 'lthr'],
  other: ['lthr'],
};

export const thresholdSport = (sport: Sport): ThresholdSport => (sport === 'ride' || sport === 'run' ? sport : 'other');

export const sportsFor = (sport: ThresholdSport): Sport[] => SPORTS.filter((s) => thresholdSport(s) === sport);

// Ride kinds keep their bare names: auto_applied stored them that way before other sports had thresholds.
export const thresholdKey = (sport: ThresholdSport, kind: ThresholdKind): string => (sport === 'ride' ? kind : `${sport}:${kind}`);
